import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "container py-5"
}
const _hoisted_2 = { class: "row mb-4" }
const _hoisted_3 = { class: "col-md-3 text-center" }
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "col-md-5" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("strong", null, "Qualification:", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("strong", null, "Matricule :", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("strong", null, "Sexe :", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("strong", null, "Email :", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("strong", null, "Téléphone :", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("strong", null, "Anne Experience:", -1)
const _hoisted_14 = { class: "col-md-4" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_17 = { key: 0 }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("strong", null, "Filière :", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("strong", null, "Niveau:", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("strong", null, "Année Académique :", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("strong", null, "Autre Qualification:", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("h4", null, "Date de naissance", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("h4", null, "Biographie", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.etu)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_ctx.etu.user?.urlImage)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: _ctx.getImageUrl(_ctx.etu.user.urlImage),
                  alt: "Photo disciple",
                  class: "detail-photo"
                }, null, 8, _hoisted_4))
              : (_openBlock(), _createElementBlock("img", {
                  key: 1,
                  src: _ctx.defaultPhoto,
                  alt: "Photo par défaut",
                  class: "detail-photo"
                }, null, 8, _hoisted_5))
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("h2", null, _toDisplayString(_ctx.etu.nom) + " " + _toDisplayString(_ctx.etu.prenom), 1),
            (_ctx.etu.qualification)
              ? (_openBlock(), _createElementBlock("p", _hoisted_7, [
                  _hoisted_8,
                  _createTextVNode(" " + _toDisplayString(_ctx.etu.qualification.libelle), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("p", null, [
              _hoisted_9,
              _createTextVNode(" " + _toDisplayString(_ctx.etu.numeroMatricule), 1)
            ]),
            _createElementVNode("p", null, [
              _hoisted_10,
              _createTextVNode(" " + _toDisplayString(_ctx.etu.sexe), 1)
            ]),
            _createElementVNode("p", null, [
              _hoisted_11,
              _createTextVNode(" " + _toDisplayString(_ctx.etu.email), 1)
            ]),
            _createElementVNode("p", null, [
              _hoisted_12,
              _createTextVNode(" " + _toDisplayString(_ctx.etu.telephone1), 1)
            ]),
            _createElementVNode("p", null, [
              _hoisted_13,
              _createTextVNode(" " + _toDisplayString(_ctx.etu.anneeExperience), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _hoisted_16,
            (_ctx.etu.inscriptions?.length)
              ? (_openBlock(), _createElementBlock("ul", _hoisted_17, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.etu.inscriptions, (inscription) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: inscription.id
                    }, [
                      _createElementVNode("p", null, [
                        _hoisted_18,
                        _createTextVNode(_toDisplayString(inscription.filiere?.libelle), 1)
                      ]),
                      _createElementVNode("p", null, [
                        _hoisted_19,
                        _createTextVNode(" " + _toDisplayString(inscription.niveau?.libelle), 1)
                      ]),
                      _createElementVNode("p", null, [
                        _hoisted_20,
                        _createTextVNode(_toDisplayString(new Date(inscription.dateInscription).getFullYear()), 1)
                      ]),
                      _createElementVNode("p", null, [
                        _hoisted_21,
                        _createTextVNode(" " + _toDisplayString(_ctx.etu.autreQualification), 1)
                      ])
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _hoisted_22,
        _hoisted_23,
        _createElementVNode("p", null, _toDisplayString(_ctx.formatDate(_ctx.etu.dateNaissance)), 1),
        _hoisted_24,
        _hoisted_25,
        _createElementVNode("p", null, _toDisplayString(_ctx.etu.biographie), 1)
      ]))
    : _createCommentVNode("", true)
}